module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "total"
  }, [_c('el-card', {
    staticClass: "box-card xs24",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-question sicon one"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("点击人数")]), _vm._v(" "), _c('div', {
    staticClass: "numText one"
  }, [_vm._v(_vm._s(_vm.c2data.total.click_uv || '0'))])])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card xs24",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-success sicon two"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("成功人数")]), _vm._v(" "), _c('div', {
    staticClass: "numText two"
  }, [_vm._v(_vm._s(_vm.c2data.total.clickok_uv || '0'))])])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card xs24",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-question sicon one"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("点击率")]), _vm._v(" "), _c('div', {
    staticClass: "numText one"
  }, [_vm._v(_vm._s(_vm.c2data.total.click_per) + "%")])])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card xs24",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-news sicon three"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("跳出率")]), _vm._v(" "), _c('div', {
    staticClass: "numText three"
  }, [_vm._v(_vm._s(_vm.c2data.total.jump_per) + "%")])])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card xs24",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-tickets sicon four"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("收入预估")]), _vm._v(" "), _c('div', {
    staticClass: "numText four"
  }, [_vm._v(_vm._s(_vm.c2data.total.income || '0'))])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "selectRow"
  }, [_c('el-col', {
    attrs: {
      "sm": 14,
      "xs": 24
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "id": "seven",
      "autofocus": "",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(1)
      }
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(7)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "xs24",
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "autofocus": "",
      "plain": ""
    },
    on: {
      "click": _vm.ExportData
    }
  }, [_vm._v("导出")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 10,
      "xs": 24
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-dropdown', {
    staticClass: "dropdown xs24",
    on: {
      "command": _vm.themeFilter
    }
  }, [_c('el-button', {
    staticClass: "dropdown",
    attrs: {
      "type": "normal"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.tText) + "\n                "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": ""
    }
  }, [_vm._v("所有类型")]), _vm._v(" "), _vm._l((_vm.config), function(v, i) {
    return _c('el-dropdown-item', {
      key: i,
      attrs: {
        "command": i
      }
    }, [_vm._v(_vm._s(v[0]))])
  })], 2)], 1), _vm._v(" "), _c('el-input', {
    ref: "input",
    staticClass: "search xs24",
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请输入发行游戏名称",
      "suffix-icon": _vm.pdata.issued_app_name.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      }
    },
    model: {
      value: (_vm.pdata.issued_app_name),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "issued_app_name", $$v)
      },
      expression: "pdata.issued_app_name "
    }
  }), _vm._v(" "), _c('el-input', {
    ref: "input",
    staticClass: "search xs24",
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请输入产品名称",
      "suffix-icon": _vm.pdata.product_name.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      }
    },
    model: {
      value: (_vm.pdata.product_name),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "product_name", $$v)
      },
      expression: "pdata.product_name"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isChartShow),
      expression: "!isChartShow"
    }],
    staticStyle: {
      "min-width": "1200px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "id": "chart"
    }
  })]), _vm._v(" "), _c('el-table', {
    staticClass: "cdata",
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.c2data.list,
      "stripe": "",
      "row-key": "keyid",
      "row-class-name": _vm.tableRowClassName
    },
    on: {
      "expand-change": _vm.expandsDay
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand",
      "prop": "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('el-table', {
          staticClass: "table2",
          attrs: {
            "data": s.row.exData,
            "show-header": false,
            "row-key": "keyid",
            "stripe": ""
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "name",
            "width": "48px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(ss) {
              return [_c('div', {
                staticClass: "moreDetail",
                on: {
                  "click": function($event) {
                    return _vm.expands(ss.row)
                  }
                }
              }, [_vm._v(" + ")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "d_date",
            "label": "日期",
            "align": "center",
            "width": "100px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "aname",
            "label": "发行游戏名称",
            "width": "120px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "pname",
            "label": "发行游戏创意名称",
            "width": "120px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "click_uv",
            "label": "创意点击数",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "clickok_uv",
            "label": "创意点击确定数",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "click_per",
            "label": "创意点击率",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.click_per != 0) ? _c('span', [_vm._v(" " + _vm._s((scope.row.click_per) + '%') + " ")]) : _c('span', [_vm._v(" -- ")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "income",
            "label": "收入预估",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "jump_per",
            "label": "跳出率",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(ss) {
              return [_vm._v("\n\t\t\t\t\t      \t\t" + _vm._s(ss.row.jump_per + '%') + "\n\t\t\t\t\t        \n\t\t\t\t\t        ")]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "click_price",
            "label": "点击单价",
            "align": "center"
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "issued_app_id",
      "label": "ID",
      "align": "center",
      "width": "148px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "aname",
      "label": "发行游戏名称",
      "width": "120px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pname",
      "label": "发行游戏创意名称",
      "width": "120px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_uv",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.click_uv - 0) - (b.click_uv - 0)
      },
      "label": "创意点击数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clickok_uv",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.clickok_uv - 0) - (b.clickok_uv - 0)
      },
      "label": "创意点击确定数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_per",
      "label": "创意点击率",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.click_per != 0) ? _c('span', [_vm._v(" " + _vm._s((scope.row.click_per) + '%') + " ")]) : _c('span', [_vm._v(" -- ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "income",
      "label": "收入预估",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.income - 0) - (b.income - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "jump_per",
      "label": "跳出率",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.jump_per - 0) - (b.jump_per - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n      \t\t" + _vm._s(scope.row.jump_per + '%') + "\n        \n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_price",
      "label": "点击单价",
      "align": "center"
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑创意组合",
      "visible": _vm.editDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.group
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "详细",
      "visible": _vm.detailDialog,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.detailDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.detailExpand,
      "row-key": "keyid"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "pname",
      "label": "Icon",
      "width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "placement": "top-start",
            "title": "Icon",
            "width": "360",
            "trigger": "hover"
          }
        }, [_c('img', {
          attrs: {
            "src": scope.row.url,
            "width": "360px"
          }
        }), _vm._v(" "), _c('img', {
          attrs: {
            "slot": "reference",
            "src": scope.row.url,
            "width": "30px"
          },
          slot: "reference"
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pname",
      "label": "发行游戏创意名称",
      "width": "120px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_uv",
      "label": "创意点击数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clickok_uv",
      "label": "创意点击确定数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_per",
      "label": "创意点击率",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.click_per != 0) ? _c('span', [_vm._v("\n\t\t\t      \t\t\t" + _vm._s((scope.row.click_per) + '%') + "\n\t\t\t      \t")]) : _c('span', [_vm._v("\n\t\t\t      \t\t--\n\t\t\t      \t")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "jump_per",
      "label": "跳出率",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ss) {
        return [_vm._v("\n\t\t      \t\t" + _vm._s(ss.row.jump_per + '%') + "\n\t\t        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "weight",
      "label": "权重",
      "align": "center"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.detailClose
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f8daca46"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/adData/cData2.vue
// module id = 1119
// module chunks = 2